import { NetworkStrength3AlertIcon } from './NetworkStrength3AlertIcon';

/**
 * author: Simran
 * id 99771A39-B621-45BA-96BE-7589E5A85B9E
 * name network-strength-3-alert
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/network-strength-3-alert.svg
 * tags
 * - Cellphone / Phone 
 * - Alert / Error 
 */
export const NetworkStrength3WarningIcon = NetworkStrength3AlertIcon;
export default NetworkStrength3WarningIcon